import React, { useState } from "react";
import "./MovieCard.css";
import { getMovieRating, getMovieReleaseYear, getMovieTitle, getPosterUrl } from "../utils/movieUtils";
import Icon from "./Icon";

export default function MovieCard({ movie, onSelect, active = false }) {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const title = getMovieTitle(movie);
  const releaseYear = getMovieReleaseYear(movie);
  const imageSrc = getPosterUrl(movie);
  const rating = getMovieRating(movie);

  return (
    <article
      className={`movie-card ${active ? "active" : ""}`}
      onClick={() => onSelect(movie)}
      onKeyDown={(event) => event.key === "Enter" && onSelect(movie)}
      role="button"
      tabIndex={0}
      aria-label={`Seleccionar ${title}`}
      aria-current={active ? "true" : undefined}
    >
      <div className={`movie-poster-wrapper ${imageSrc && !isImageLoaded ? "is-loading" : ""}`}>
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={title}
            className={`movie-poster ${isImageLoaded ? "is-loaded" : ""}`}
            loading="lazy"
            onLoad={() => setIsImageLoaded(true)}
          />
        ) : (
          <div className="movie-poster fallback-poster">
            <Icon name="search" size={22} />
            <span>Sin imagen</span>
          </div>
        )}

        {rating ? (
          <span className="movie-rating-badge">
            <Icon name="star" size={11} />
            {rating}
          </span>
        ) : null}

        {active ? <span className="movie-active-badge">En hero</span> : null}

        <div className="movie-hover-overlay">
          <span className="movie-hover-label">Ver detalle</span>
        </div>
      </div>
      <h3>{title}</h3>
      <p className="movie-year">{releaseYear}</p>
    </article>
  );
}
